import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";
import {
  TextField,
  Loadable,
  DescriptionField,
  CheckBox,
  SelectField
} from "components/support";

import EmailConfig from "./email-config";
import AdditionalMessageConfig from "./additional-message-config";

class CompanyFormGeneralInfo extends Component {
  constructor(props) {
    super(props);
    props.viewModel.company = props.company;
  }

  handleCnpjChange = value => {
    this.props.company.fiscal_informations.cnpj = value;
    this.props.presenter.onCnpjChange();
  };

  render() {
    const { company, errors, viewModel } = this.props;
    const { loading } = viewModel;
    return (
      <div className="grid-container">
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <div className="grid-container mt-sm mb-sm">
                <Row bottom="xs">
                  <Col xs={6}>
                    <CheckBox
                      checked={company.print_sale_list}
                      style={checkBoxStyle}
                      label="Imprimir relatório de vendas"
                      onCheck={checked => (company.print_sale_list = checked)}
                    />
                  </Col>
                  <Col xs={6}>
                    <CheckBox
                      checked={company.print_detailed_sale}
                      style={checkBoxStyle}
                      label="Imprimir venda detalhada"
                      onCheck={checked =>
                        (company.print_detailed_sale = checked)
                      }
                    />
                  </Col>
                </Row>
                <Row bottom="xs">
                  <Col xs={6}>
                    <CheckBox
                      checked={company.show_sellable_image}
                      style={checkBoxStyle}
                      label="Mostrar imagens dos produtos"
                      onCheck={checked =>
                        (company.show_sellable_image = checked)
                      }
                    />
                  </Col>
                  <Col xs={6}>
                    <CheckBox
                      checked={company.scan_barcode_by_camera}
                      style={checkBoxStyle}
                      label="Usar camera como leitor"
                      onCheck={checked =>
                        (company.scan_barcode_by_camera = checked)
                      }
                    />
                  </Col>
                </Row>
                <Row bottom="xs">
                  <Col xs={6}>
                    <CheckBox
                      checked={company.open_sales}
                      style={checkBoxStyle}
                      label="Permitir fazer venda em aberto"
                      onCheck={checked => (company.open_sales = checked)}
                    />
                  </Col>
                  <Col xs={6}>
                    <CheckBox
                      checked={company.customers}
                      style={checkBoxStyle}
                      label="Gerenciar clientes"
                      onCheck={checked => (company.customers = checked)}
                    />
                  </Col>
                </Row>
                <Row bottom="xs">
                  <Col xs={6}>
                    <CheckBox
                      checked={company.email_low_stock}
                      style={checkBoxStyle}
                      label="Ativar notificação de estoque mínimo"
                      onCheck={checked => (company.email_low_stock = checked)}
                    />
                    <Tooltip
                      id="tooltip-top"
                      title="Enviado todo dia as 8h"
                      placement="right"
                    >
                      <Icon style={iconStyle}>info</Icon>
                    </Tooltip>
                  </Col>
                  <Col xs={6}>
                    <CheckBox
                      checked={company.block_sale_when_stock_is_zero}
                      style={checkBoxStyle}
                      label="Bloquear vendas com estoque negativo"
                      onCheck={checked =>
                        (company.block_sale_when_stock_is_zero = checked)
                      }
                    />
                  </Col>
                </Row>
                <Row bottom="xs">
                  <Col xs={6}>
                    <SelectField
                      floatingLabelText="Tamanho dos Cards do Produto"
                      value={company.size_card_mobile}
                      onChange={(_, value) =>
                        (company.size_card_mobile = value)
                      }
                      underlineStyle={{ bottom: "0" }}
                      labelStyle={{ height: "44px" }}
                      fullWidth
                      options={[
                        { value: "use_normal_cards", label: "Normal" },
                        { value: "use_medium_cards", label: "Médio" },
                        { value: "use_large_cards", label: "Grande" }
                      ]}
                    />
                  </Col>
                  <Col xs={6}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={company.notify_email}
                      disabled={!company.email_low_stock}
                      floatingLabelFixed
                      floatingLabelText="E-mail de aviso de estoque mínimo atingido"
                      onChange={(_, value) => (company.notify_email = value)}
                      errorText={errors.notify_email}
                    />
                  </Col>
                </Row>
                <Row bottom="xs">
                  <Col xs={6}>
                    <TextField
                      fullWidth
                      underlineShow={false}
                      value={company.max_installments}
                      floatingLabelFixed
                      floatingLabelText="Quantidade máxima de parcelas"
                      onChange={(_, value) =>
                        (company.max_installments = value.replace(/\D/g, ""))
                      }
                      errorText={errors.max_installments}
                    />
                  </Col>
                  <Col xs={12}>
                    <DescriptionField
                      label="UUID da Empresa"
                      value={company.uuid ? company.uuid : null}
                    />
                  </Col>
                </Row>
                <Row bottom="xs">
                  <Col xs={12}>
                    <CheckBox
                      checked={company.show_sellable_list}
                      label="Exibir atalhos para produtos no Aplicativo"
                      onCheck={checked =>
                        (company.show_sellable_list = checked)
                      }
                    />
                  </Col>
                </Row>
                <AdditionalMessageConfig
                  company={company}
                  onChange={value =>
                    (company.receipt_additional_message = value)
                  }
                />
                <EmailConfig
                  company={company}
                  onChange={(template, value) =>
                    (company.email_texts[template] = value)
                  }
                />
              </div>
            </Loadable>
          </Col>
        </Row>
      </div>
    );
  }
}

const checkBoxStyle = {
  paddingLeft: 4
};

const iconStyle = {
  marginLeft: 10,
  fontSize: 16
};

export default CompanyFormGeneralInfo;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/config-app/general-info.view.jsx